import Javascript from '../images/skills/javascript.png'
import Typescript from '../images/skills/typescript.png'
import HTML from '../images/skills/html.png'
import Python from '../images/skills/python.png'
import Ruby from '../images/skills/ruby.png'
import CSS from '../images/skills/css.png'
import React from '../images/skills/react.png'
import Django from '../images/skills/django.png'
import Rails from '../images/skills/ror.png'
import NodeJS from '../images/skills/nodejs.png'
import JQuery from '../images/skills/jquery.png'
import Bootstrap from '../images/skills/bootstrap.png'
import SemanticUI from '../images/skills/semanticui.png'
import Postgresql from '../images/skills/postgresql.png'
import Mysql from '../images/skills/mysql.png'
import MongoDB from '../images/skills/mongodb.png'
import Photoshop from '../images/skills/photoshop.png'
import Arduino from '../images/skills/arduino.png'
import RaspberryPI  from '../images/skills/raspberrypi.png'

const languages = [
    {
        name: 'Javascript',
        color: 'rgb(245,222,25)',
        image: Javascript
    },
    {
        name: 'Typescript',
        color: 'rgb(49, 120, 198)',
        image: Typescript
    },
    {
        name: 'Python',
        color: 'rgb(52,122,180)',
        image: Python
    },
    {
        name: 'Ruby',
        color: 'rgb(153, 18, 11)',
        image: Ruby
    },
    {
        name: 'HTML5',
        color: 'rgb(241,102,42)',
        image: HTML
    },
    {
        name: 'CSS',
        color: 'rgb(3,155,229)',
        image: CSS
    },
]

const frameworks = [
    {
        name: 'React',
        color: 'rgb(34,34,34)',
        image: React
    },
    {
        name: 'Django',
        color: 'rgb(9,46,32)',
        image: Django
    },
    {
        name: 'Ruby on Rails',
        color: 'rgb(204,0,0)',
        image: Rails
    },
    {
        name: 'NodeJS',
        color: 'rgb(131,205,40)',
        image: NodeJS
    },
    {
        name: 'JQuery',
        color: 'rgb(8,104,172)',
        image: JQuery
    },
    {
        name: 'Bootstrap',
        color: 'rgb(103,58,183)',
        image: Bootstrap
    },
    {
        name: 'SemanticUI',
        color: 'rgb(52,189,178)',
        image: SemanticUI
    }
]

const databases = [
    {
        name: 'Postgresql',
        color: 'rgb(50,102,144)',
        image: Postgresql
    },
    {
        name: 'Mysql',
        color: 'rgb(0,113,140)',
        image: Mysql
    },
    {
        name: 'MongoDB',
        color: 'rgb(89,150,54)',
        image: MongoDB
    },
]

const misc = [
    {
        name: 'Photoshop',
        color: 'rgb(0,30,54)',
        image: Photoshop
    },
    {
        name: 'Arduino',
        color: 'rgb(0,150,136)',
        image: Arduino
    },
    {
        name: 'RaspberryPI',
        color: 'rgb(107,192,72)',
        image: RaspberryPI
    },
]

const data = {
    languages,
    frameworks,
    databases,
    misc
}

export default data